import React, { useState } from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import RightPathWhite from "assets/rightpathWhite.png";
import RightPath from "assets/rightPath.svg";
import { useTranslation } from "react-i18next";

import { COLORS, SIZES } from "theme";
import H2 from "ReusableComponents/Text/H2";
import Button from "ReusableComponents/Button";
import { useLanguage } from "LanguageContext";

const Compare = ({ small, medium }) => {
  const { t } = useTranslation();
  const { selectedLanguage } = useLanguage();

  const [hover, setHover] = useState(false);

  return (
    <Box display="flex" flexDirection="column" padding={!small && "0 40px"}>
      <H2
        textColor="white"
        fontSize={small ? SIZES.twenty : "40px"}
        fontWeight="bold"
      >
        Explore Variants
      </H2>
      <Button
        isHover={true}
        border="none"
        background={hover ? COLORS.black : COLORS.primary}
        display="flex"
        w={small ? "max-content" : "287px"}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        margin="36px 0"
        onClick={() =>
          (window.location.href = `/${selectedLanguage}/test-ride`)
        }
      >
        <Text
          fontSize={small ? SIZES.twelve : "16px"}
          fontWeight="bold"
          textColor={hover ? COLORS.white : COLORS.black}
        >
          {t("Book a Test Ride")}
        </Text>
        <img
          src={hover ? RightPathWhite : RightPath}
          alt="rightPath"
          style={{ margin: "0 8px" }}
          height="16px"
        />
      </Button>
    </Box>
  );
};

export default Compare;
